import { Component, type ReactNode } from 'react';

interface ModalErrorBoundaryProps {
  onError: (error: unknown) => void;
  children: ReactNode;
}

interface ModalErrorBoundaryState {
  hasError: boolean;
}

export class ModalErrorBoundary extends Component<ModalErrorBoundaryProps, ModalErrorBoundaryState> {
  constructor(props: ModalErrorBoundaryProps) {
    super(props);

    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): ModalErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: unknown) {
    const { onError } = this.props;

    onError(error);
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) return null;

    return children;
  }
}
